export enum UserRole {
  Admin = 'admin',
  Client = 'clientuser',
  Provider = 'organizationuser'
}